import { useState } from "react";

import styles from "@styles/forms-flow/creative.module.scss";

import {
  Button,
  Drawer,
  Hairline,
  Label,
  Select,
  Steps as StepsComponent,
} from "@components";

import { OlgaEnvironmentsAPI } from "@providers/OlgaEnvironmentsAPI";
import { BenefitDetails } from "./components/BenefitDetails";
import { BenefitType } from "./components/BenefitType";
import { CreativeName } from "./components/CreativeName";
import { GainReminder } from "./components/GainReminder";
import { PlaceBenefitUse } from "./components/PlaceBenefitUse";
import { SpendReminder } from "./components/SpendReminder";

import mergeObjects from "lodash.merge";
import { useEffect } from "react";
import { BenefitEnvironment } from "./components/BenefitEnvironment";
import { ContemplationInterval } from "./components/ContemplationInterval";
import { WhatsAppMessage } from "./components/WhatsAppMessage";
import { FlowAPI } from "providers/FlowAPI";
import { WhatsAppPreview } from "./components/WhatsAppPreview";

const Steps = {
  NAME: 1,
  CONTEMPLATION: 2,
  BENEFIT_TYPE: 3,
  BENEFIT_DETAILS: 4,
  PLACE_BENEFIT_USE: 5,
  PLACE_BENEFIT_BRNAD: 6,
  MESSAGE_WHATSAPP: 7,
  FINISHED: 12,
};

export const WhatsAppCreativeActionFormOld = ({
  visible,
  onClose,
  flowType,
  node,
  restrictions,
  onChange,
  onSave,
}) => {
  const [steps, setSteps] = useState(Object.keys(Steps).length);
  const [currentStep, setCurrentStep] = useState(Steps.NAME);
  const [creative, setCreative] = useState({
    creative: node?.data?.creative || {},
    coupon: node?.data?.coupon || {},
  });
  const [isValid, setIsValid] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [brandsList, setBrands] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const getFreshNode = (data) => {
    return {
      ...node,
      data: {
        ...node.data,
        ...data,
      },
    };
  };

  const getBrands = async () => {
    try {
      const response = await OlgaEnvironmentsAPI.getBrands();
      const brands = response.getData([]);
      setBrands(brands);
    } catch (error) {
      setBrands([]);
    }
  };

  useEffect(() => {
    getBrands();
  }, []);

  const getTemplates = async () => {
    // InfoBip
    // const response = await OlgaEnvironmentsAPI.getWhatsappTemplates();
    // const data = response.getData([]);
    // const templatesApproved = (data || []).filter(
    //   (template) => template.status == "APPROVED"
    // );

    const response = await FlowAPI.getWhatsAppResourceTemplates({
      environmentId: node?.environmentId,
    });

    const data = response.getData([]);
    const templatesApproved = (data || []);

    if (templatesApproved.length == 0) {
      return setTemplates([{
        label: "Não há templates aprovados",
        value: null,
      }]);
    }

    setTemplates(templatesApproved);
    setSelectedTemplate(templatesApproved.find((t) => t.id === creative?.template_id));
  };

  useEffect(() => {
    if (restrictions?.lockCreativeBenefit) {
      setSteps(
        Object.values(Steps).filter((stepIndex) =>
          [Steps.NAME, Steps.MESSAGE_WHATSAPP].includes(stepIndex)
        )
      );
    }
  }, []);

  useEffect(() => {
    getTemplates();
  }, []);

  useEffect(() => {
    const c = {
      creative: node?.data?.creative || {},
      coupon: node?.data?.coupon || {},
    };
    setCreative(c);
    setIsValid(isValidStep(currentStep, c, flowType));
  }, [node]);

  useEffect(() => {
    setIsValid(isValidStep(currentStep, creative, flowType));
  }, [currentStep]);

  const onChangeCreative = (branch, value) => {
    let newCreative = {
      ...creative,
      [branch]: {
        ...(creative[branch] || {}),
        ...value,
      },
    };

    if (branch === "creative" && value.templateId) {
      newCreative = {
        ...newCreative,
        message: {
          ...(newCreative.message || {}),
          templateId: value.templateId,
        },
      };
    }

    setCreative(newCreative);
    setIsValid(isValidStep(currentStep, newCreative, flowType));
    onChange && onChange(getFreshNode(newCreative));
    return getFreshNode(newCreative);
  };

  const nextStep = (futureCreative) => {
    const nextStep = getNextStep(
      currentStep,
      futureCreative || creative,
      restrictions,
      brandsList || []
    );
    onSave && onSave(getFreshNode(futureCreative || creative), false);

    return nextStep;
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => {
        setCurrentStep(Steps.NAME);
        onClose();
      }}
      showBackButton={currentStep > Steps.NAME && currentStep != Steps.FINISHED}
      backButton={() =>
        setCurrentStep((prevState) =>
          getPrevStep(prevState, creative, restrictions, brandsList || [])
        )
      }
      title={"Adicionar um criativo - WhatsApp"}
    >
      <StepsComponent steps={steps} stepsIsArray currentStep={currentStep} />

      <div className={styles.scrollContainer}>
        {currentStep === Steps.NAME && (
          <CreativeName
            node={node}
            flowType={flowType}
            restrictions={restrictions}
            creative={creative?.creative}
            onChangeCreative={(data) => onChangeCreative("creative", data)}
          />
        )}

        {currentStep === Steps.CONTEMPLATION && (
          <ContemplationInterval
            creative={creative?.creative}
            onChangeCreative={(data) => {
              onChangeCreative("creative", data);
            }}
          />
        )}

        {currentStep === Steps.BENEFIT_TYPE && (
          <BenefitType
            selectedBenefit={creative?.coupon?.type}
            setSelectedBenefit={(type) => {
              onChangeCreative("coupon", { type });
            }}
          />
        )}

        {currentStep === Steps.BENEFIT_DETAILS && (
          <BenefitDetails
            coupon={creative?.coupon}
            onChangeCreative={(data) => onChangeCreative("coupon", data)}
          />
        )}

        {currentStep === Steps.PLACE_BENEFIT_BRNAD && (
          <BenefitEnvironment
            benefit={creative?.coupon}
            brands={brandsList}
            onChange={(data) => onChangeCreative("coupon", data)}
          />
        )}

        {currentStep === Steps.PLACE_BENEFIT_USE && (
          <PlaceBenefitUse
            coupon={creative?.coupon}
            onChangeCreative={(data) => onChangeCreative("coupon", data)}
          />
        )}

        {currentStep === Steps.MESSAGE_WHATSAPP && (
          <>
            <Label>Selecione o template aprovado</Label>
            {/* <Select
              value={creative.creative?.message?.templateId}
              onChange={(e) => {
                onChangeCreative("creative", {
                  message: {
                    templateId: e.target.value,
                    type: "WHATSAPP",
                  },
                });
              }}
              options={templates}
            /> */}
            <Select
              value={creative.creative?.template_id}
              onChange={(e) => {
                const new_template = templates.find((t) => t.id === e.target.value);
                setSelectedTemplate(new_template);
                onChangeCreative("creative", {
                  template_id: new_template.id,
                  message: {
                    type: "WHATSAPP",
                    template: new_template,
                  },
                });
              }}
              options={
                templates.map(
                  (item) => ({
                    label: item.name,
                    value: item.id,
                    content: item.content,
                  })
                )
              }
            />

            {creative.creative?.message?.template && (
              <>
                <Hairline className="mt-30 mb-30" />
                <WhatsAppPreview
                  components={creative.creative?.message?.template?.components || []}
                  coupon={creative?.coupon}
                />
                <Hairline className="mt-30 mb-30" />
                <WhatsAppMessage
                  template_id={creative.creative?.template_id}
                  coupon={creative?.coupon}
                />
              </>
            )}
          </>
        )}

        {currentStep === Steps.GAIN_REMINDER && (
          <GainReminder
            coupon={creative?.coupon}
            onChangeCreative={(data) => {
              const tmp = creative?.coupon?.expiration || {};
              onChangeCreative("coupon", {
                expiration: mergeObjects(tmp, {
                  gain: { remind: data },
                }),
              });
            }}
          />
        )}
        {currentStep === Steps.GAIN_REMINDER_WHATSAPP && (
          <>
            <Label>Selecione o template aprovado</Label>
            <Select
              value={
                creative.coupon?.expiration?.gain?.remind?.message?.templateId
              }
              onChange={(e) => {
                const tmp = creative?.coupon?.expiration || {};
                onChangeCreative("coupon", {
                  expiration: mergeObjects(tmp, {
                    gain: {
                      remind: {
                        message: {
                          templateId: e.target.value,
                          type: "WHATSAPP",
                        },
                      },
                    },
                  }),
                });
              }}
              options={templates}
            />

            <Hairline className="mt-30 mb-30" />

            <WhatsAppMessage
              message={creative.coupon?.expiration?.gain?.remind?.message}
              coupon={creative?.coupon}
            />
          </>
        )}

        {currentStep === Steps.SPEND_REMINDER && (
          <SpendReminder
            coupon={creative?.coupon}
            onChangeCreative={(data) => {
              const tmp = creative?.coupon?.expiration || {};
              onChangeCreative("coupon", {
                expiration: mergeObjects(tmp, {
                  spend: { remind: data },
                }),
              });
            }}
          />
        )}
        {currentStep === Steps.SPEND_REMINDER_WHATSAPP && (
          <>
            <Label>Selecione o template aprovado</Label>
            <Select
              value={
                creative.coupon?.expiration?.spend?.remind?.message?.templateId
              }
              onChange={(e) => {
                const tmp = creative?.coupon?.expiration || {};
                onChangeCreative("coupon", {
                  expiration: mergeObjects(tmp, {
                    spend: {
                      remind: {
                        message: {
                          templateId: e.target.value,
                          type: "WHATSAPP",
                        },
                      },
                    },
                  }),
                });
              }}
              options={templates}
            />

            <Hairline className="mt-30 mb-30" />

            <WhatsAppMessage
              message={creative.coupon?.expiration?.spend?.remind?.message}
              coupon={creative?.coupon}
            />
          </>
        )}

        {currentStep === Steps.FINISHED && (
          <div className={styles.finished}>
            <i className="far fa-check" />
            <p>Seu disparo foi configurado com sucesso!</p>
          </div>
        )}
      </div>

      <div className={styles.footer}>
        <div className="d-flex flex-column w-100">
          {currentStep !== Steps.FINISHED && (
            <>
              {currentStep === Steps.BENEFIT_TYPE && (
                <Button
                  className="w-100 mb-15"
                  design="default-2"
                  onClick={() => {
                    const futureCreative = onChangeCreative("coupon", {
                      type: null,
                    });
                    setCurrentStep(nextStep(futureCreative));
                  }}
                >
                  Não conceder benefícios
                </Button>
              )}

              <Button
                className="w-100"
                disabled={!isValid}
                onClick={() => setCurrentStep(nextStep())}
                design="primary"
              >
                {Steps.GAIN_REMINDER !== currentStep ? "Próximo" : "Finalizar"}
              </Button>
            </>
          )}

          {currentStep === Steps.FINISHED && (
            <Button
              className="w-100"
              onClick={() => {
                setCurrentStep(Steps.NAME);
                setCreative({});
                onClose();
              }}
            >
              Voltar para fluxos
            </Button>
          )}
        </div>
      </div>
    </Drawer>
  );
};

const getNextStep = (
  currentStep,
  { creative, coupon },
  restrictions = {},
  brandsList = []
) => {
  if (restrictions?.lockCreativeBenefit == true) {
    switch (currentStep) {
      case Steps.NAME:
        return Steps.MESSAGE_WHATSAPP;
      case Steps.MESSAGE_WHATSAPP:
        return Steps.FINISHED;
      default:
        return currentStep;
    }
  }

  switch (currentStep) {
    case Steps.NAME:
      return Steps.CONTEMPLATION;
    case Steps.CONTEMPLATION:
      return Steps.BENEFIT_TYPE;
    case Steps.BENEFIT_TYPE:
      return coupon?.type ? Steps.BENEFIT_DETAILS : Steps.MESSAGE_WHATSAPP;
    case Steps.BENEFIT_DETAILS:
      return Steps.PLACE_BENEFIT_USE;
    case Steps.PLACE_BENEFIT_USE:
      return Steps.MESSAGE_WHATSAPP;
    case Steps.PLACE_BENEFIT_BRNAD:
      if (coupon?.type && (brandsList || []).length > 1) {
        return Steps.PLACE_BENEFIT_BRNAD;
      }
      return Steps.MESSAGE_WHATSAPP;
    case Steps.MESSAGE_WHATSAPP:
      // if (coupon?.type) {
      //   return Steps.GAIN_REMINDER;
      // }
      return Steps.FINISHED;
    case Steps.GAIN_REMINDER:
      if (coupon.expiration?.gain?.remind?.active) {
        return Steps.GAIN_REMINDER_WHATSAPP;
      }
      // else if (coupon?.type == "CASHBACK") {
      //     return Steps.SPEND_REMINDER;
      // }
      return Steps.FINISHED;
    case Steps.GAIN_REMINDER_WHATSAPP:
      // if (coupon?.type == "CASHBACK") {
      //     return Steps.SPEND_REMINDER;
      // }
      return Steps.FINISHED;
    // case Steps.SPEND_REMINDER:
    //     if (coupon.expiration?.spend?.remind?.active) {
    //         return Steps.SPEND_REMINDER_WHATSAPP;
    //     }
    //     return Steps.FINISHED;
    // case Steps.SPEND_REMINDER_WHATSAPP:
    //     return Steps.FINISHED;
    default:
      return currentStep;
  }
};

const getPrevStep = (
  currentStep,
  { creative, coupon },
  restrictions = {},
  brandsList = []
) => {
  if (restrictions?.lockCreativeBenefit) {
    switch (currentStep) {
      case Steps.NAME:
        return null;
      case Steps.MESSAGE_WHATSAPP:
        return Steps.NAME;
      default:
        return currentStep;
    }
  }

  switch (currentStep) {
    case Steps.NAME:
      return null;
    case Steps.CONTEMPLATION:
      return Steps.NAME;
    case Steps.BENEFIT_TYPE:
      return Steps.CONTEMPLATION;
    case Steps.BENEFIT_DETAILS:
      return Steps.BENEFIT_TYPE;
    case Steps.PLACE_BENEFIT_USE:
      if (coupon.type && brandsList && (brandsList || []).length > 0) {
        return Steps.PLACE_BENEFIT_BRNAD;
      } else if (coupon.type) {
        return Steps.BENEFIT_TYPE;
      }
      return Steps.BENEFIT_DETAILS;
    case Steps.PLACE_BENEFIT_BRNAD:
      return Steps.BENEFIT_DETAILS;
    case Steps.MESSAGE_WHATSAPP:
      if (coupon?.type) {
        return Steps.PLACE_BENEFIT_USE;
      }
      return Steps.BENEFIT_TYPE;
    case Steps.GAIN_REMINDER:
      return Steps.MESSAGE_WHATSAPP;
    case Steps.GAIN_REMINDER_WHATSAPP:
      return Steps.GAIN_REMINDER;
    // case Steps.SPEND_REMINDER:
    //     if (coupon.expiration?.gain?.remind?.active) {
    //         return Steps.GAIN_REMINDER_WHATSAPP;
    //     }
    //     return Steps.GAIN_REMINDER;
    // case Steps.SPEND_REMINDER_WHATSAPP:
    //     return Steps.SPEND_REMINDER;
    default:
      return currentStep;
  }
};

const isValidStep = (currentStep, data, flowType) => {
  const { creative, coupon } = data;

  switch (currentStep) {
    case Steps.NAME:
      return !!creative?.name && !!(flowType == "EVENT" || creative?.sendTime);
    case Steps.CONTEMPLATION:
      return !!creative?.contemplation && !!creative?.contemplation?.type;
    case Steps.BENEFIT_TYPE:
      return !!coupon.type;
    case Steps.BENEFIT_DETAILS: {
      const isBaseValid =
        !!coupon.code &&
        !!coupon.min_order &&
        (coupon?.type == "FREE_DELIVERY" || !!coupon?.value);

      const hasSkus = coupon.skus?.length > 0;
      const hasProductName = (coupon.description || "").length > 0;

      const isCouponProductOk =
        ["PRODUCT_DISCOUNT", "PRODUCT_CASH_DISCOUNT"].includes(coupon.type) &&
        hasSkus &&
        hasProductName &&
        isBaseValid;

      if (isCouponProductOk) return true;

      if (
        !["CASHBACK", "PRODUCT_DISCOUNT", "PRODUCT_CASH_DISCOUNT"].includes(
          coupon.type
        )
      ) {
        return isBaseValid;
      }
      return isBaseValid && !!coupon?.expiration?.gain?.days;
      // && !!coupon?.expiration?.spend?.days;
    }
    case Steps.PLACE_BENEFIT_USE:
      return !!coupon.type_use;
    case Steps.MESSAGE_WHATSAPP:
      return !!creative?.template_id;
    case Steps.GAIN_REMINDER: {
      const { active, days, time } = coupon?.expiration?.gain?.remind || {};
      return active === false || (!!days && !!time);
    }
    case Steps.GAIN_REMINDER_WHATSAPP: {
      const message = coupon?.expiration?.gain?.remind?.message;
      return !!message?.templateId;
    }
    case Steps.SPEND_REMINDER: {
      const { active, days, time } = coupon?.expiration?.spend?.remind || {};
      return active === false || (!!days && !!time);
    }
    case Steps.PLACE_BENEFIT_BRNAD:
      return !!(coupon?.brands_valid?.length > 0);
    case Steps.SPEND_REMINDER_WHATSAPP: {
      const message = coupon?.expiration?.spend?.remind?.message;
      return !!message?.templateId;
    }
  }

  return true;
};
